// src/router/stock.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const stockRoutes: RouteRecordRaw[] = [
  {
    path: 'stock',
    name: 'stock',
    component: () => import('@/views/page/stock/StockData.vue'),
    meta: { title: 'Stock' },
  },
  {
    path: 'stock/trash',
    name: 'stock-trash',
    component: () => import('@/views/page/stock/StockData.vue'),
    meta: { title: 'Stock Trash' },
  },
  {
    path: 'stock/create/',
    name: 'stock-create',
    component: () => import('@/views/page/stock/StockInput.vue'),
    meta: { title: 'Create Stock' },
  },
  {
    path: 'stock/:id/edit',
    name: 'stock-edit',
    component: () => import('@/views/page/stock/StockInput.vue'),
    meta: { title: 'Edit Stock' },
  },
]
